import React from "react";
import "./style.scss";
import Heading from "../../elements/heading";
import PropTypes from "prop-types";
import { SuperButton } from "../../elements";

const SetNewPasswordConfirmation = ({ headingType, headingBody, body, button }) => {
  return (
    <div className="set-new-password-confirmation">
      {headingType && headingBody && <Heading type={headingType} className="title show-on-scroll" html={headingBody} typographyClass="type-h3" />}

      {body && (
        <div
          className={"body-text"}
          dangerouslySetInnerHTML={{
            __html: body.value
          }}
        />
      )}

      <div className="button-container">{button && <SuperButton {...button} />}</div>
    </div>
  );
};

SetNewPasswordConfirmation.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.string,
  button: PropTypes.object
};

export default SetNewPasswordConfirmation;
